import React, { useState } from "react";
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import ErrorSharpIcon from "@mui/icons-material/ErrorSharp";
import TopicIcon from '@mui/icons-material/Topic';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import DescriptionIcon from '@mui/icons-material/Description';
import commonApiService from '../../../../shared/common-utilities/services/commonApiService';
import {
    IconButton,
    Stack,
} from "@mui/material";
import { baseUrl, getMovement } from "../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts";
import { Checkbox, Switch } from "@progress/kendo-react-inputs";

const apiService = commonApiService()

export const CustomInfoCell = props => {

    const [infoTooltip, setInfoTooltip] = useState('');
    const [infoTooltipId, setInfoTooltipId] = useState(null);
    const getInstructions = async (id) => {
        setInfoTooltip();
        setInfoTooltipId();
        let url;
        if (props.cells.gridFlagVal === "movements") {
                url = `${baseUrl}/${props.cells.gridFlagVal}(${id})?$select=id&$expand=shipmentInstructions($select=description)`;
        } else if (props.cells.gridFlagVal === "routes") {
                url = `${baseUrl}/${props.cells.gridFlagVal}(${id})?$select=id&$expand=routeInstructions($select=description)`;
        } else if (props.cells.gridFlagVal === "ptmovements") {
            url = `${baseUrl}/${props.cells.gridFlagVal}(${id})?$select=id&$expand=shipmentInstructions($select=description)`;
        } else {
                url = `${baseUrl}/${props.cells.gridFlagVal}(${id})?$select=id&$expand=tripInstructions($select=description)`; 
        }
        const response = await apiService.get(url);
        if (response) {
            if (props.cells.gridFlagVal === "movements" && response?.shipmentInstructions?.length > 0) {
                setInstruction(id, response.shipmentInstructions);
            } else if (props.cells.gridFlagVal === "routes" && response?.routeInstructions?.length > 0) {
                setInstruction(id, response.routeInstructions);
            } else if (props.cells.gridFlagVal === "ptmovements" && response?.shipmentInstructions?.length > 0) {
                setInstruction(id, response.shipmentInstructions);
            } else if (props.cells.gridFlagVal === "partialTrips" && response?.tripInstructions?.length > 0) {
                setInstruction(id, response.tripInstructions);
            }
        }
        return response;
    }

    const setInstruction = (id, shipmentInstructions) => {
        setInfoTooltipId(id);
        let tooltipMessage = '';
        for (const shipmentInstruction of shipmentInstructions) {
            if (tooltipMessage.length > 0 && shipmentInstruction.description !== null && shipmentInstruction.description !== undefined && shipmentInstruction.description.length > 0) {
                tooltipMessage += ' | ';
            }
            tooltipMessage += shipmentInstruction.description;
        }
        setInfoTooltip(tooltipMessage);
    }

    if (props.dataItem.aggregates) {
        return (
            <td className={props.className} style={props.style}></td>
        );
    } else if (props.dataItem.instructionsExist) {
        return (
            <td className={props.className} style={props.style }>
                <LightTooltip placement="left"
                    title={props.dataItem.id === infoTooltipId && infoTooltip}
                >
                    <InfoIcon sx={{ color: "warning.main", mt:0 ,justifyContent:"center"}} onMouseOver={() => infoTooltip === '' && getInstructions(props.dataItem.id)} />
                </LightTooltip>
            </td>
            // <td className={props.className} style={props.style}>
            //     <LightTooltip placement="left"
            //         title={props.dataItem.instructions}
            //     >
            //         <InfoIcon sx={{ color: "warning.main" }} onMouse/>
            //     </LightTooltip>
            // </td>
        );
    } else {
        return (
            <td className={props.className} style={props.style}></td>
        );
    }
};

export const CustomQualificationCell = props => {

    const [qualTooltip, setQualTooltip] = useState('');
    const [qualTooltipId, setQualTooltipId] = useState(null);

    const getQualification = async (id) => {
        {
            setQualTooltip();
            setQualTooltipId();
            const response = await apiService.postWithId(getMovement,null,id,'Microsoft.NAV.getQualificationToolTip', {});
            if (response.value.length > 0) {
                setQualTooltipId(id);
                // let tooltipMessage = '';
                // for (const shipmentInstruction of response.shipmentInstructions) {
                //     if (tooltipMessage.length > 0 && shipmentInstruction.description !== null && shipmentInstruction.description !== undefined && shipmentInstruction.description.length > 0) {
                //         tooltipMessage += ' | ';
                //     }
                //     tooltipMessage += shipmentInstruction.description;
                // }
                // setQualTooltip(tooltipMessage);
                setQualTooltip(response.value);
            }
            return response.value;
        }
    }

    if (props.dataItem.aggregates) {
        return (
            <td className={props.className} style={props.style}></td>
        );
    } else if (props.dataItem.qualificationsExist) {
        return (
            <td className={props.className} style={props.style}>
                <LightTooltip placement="left"
                    title={props.dataItem.id === qualTooltipId && qualTooltip}>
                    <ErrorSharpIcon sx={{ color: "warning.main", mt:0.5 }} onMouseOver={() => qualTooltip === '' && getQualification(props.dataItem.id)} />
                </LightTooltip>
            </td>
            // <td className={props.className} style={props.style}>
            //     <LightTooltip placement="left"
            //         title={props.dataItem.qualifications}
            //     >
            //         <ErrorSharpIcon sx={{ color: "warning.main" }} />
            //     </LightTooltip>
            // </td>
        );
    } else {
        return (
            <td className={props.className} style={props.style}></td>
        );
    }
};

export const CustomBooleanCell = props => {
    return (<td className={props.className} style={props.style}>
        {/* <Switch disabled={true} checked={props.dataItem[props.cells.column.field]} /> */}
        <Checkbox disabled={true} checked={props.dataItem[props.cells.column.field]} />
    </td>);
}

export const CustomActionDrillDown = props => {
    console.log('customActionDrillDown')    
    const companyId = localStorage.getItem("companyId");
    const IconClickfordrillDownMov = (iconIndex) => {
        apiService.postWithId(getMovement,null,props.dataItem.id,'Microsoft.NAV.getUrlMovement', {}).then(res => {
            const url = res.value;
            setUrl(url);
            if (url) {
                window.open(url, '_blank');
            }
        })
    };

    const IconClickfordrillDownShip = (iconIndex) => {
        apiService.postWithId(getMovement,null,props.dataItem.id,'Microsoft.NAV.getUrlShipment', {}).then(res => {
            const url = res.value;
            setUrl(url);
            if (url) {
                window.open(url, '_blank');
            }
        })
    };

    const IconClickfordrillDownFile = (iconIndex) => {
        apiService.postWithId(getMovement,null,props.dataItem.id,'Microsoft.NAV.getUrlFileTpt', {}).then(res => {
            const url = res.value;
            setUrl(url);
            if (url) {
                window.open(url, '_blank');
            }
        })
    };
    const IconClickfordrillDownTrip = (iconIndex) => {
        apiService.postWithId(getMovement,null,props.dataItem.id,'Microsoft.NAV.getUrlTrip', {}).then(res => {
            const url = res.value;
            setUrl(url);
            if (url) {
                window.open(url, '_blank');
            }
        })
    };

    if (props.dataItem.aggregates) {
        return (
            <td className={props.className} style={props.style}></td>
        );
    } else {
        return (
            <td className={props.className} style={props.style}>
                <Stack spacing={.5} direction="row">
                    <LightTooltip placement="left" title="Drill Down Movemnet">
                        <IconButton onClick={() => IconClickfordrillDownMov(1)} sx={{ background: 'white', p: 0.3 }} size="small" color="primary">
                            <TopicIcon sx={{ padding: '0px 0px' }} />
                        </IconButton>
                    </LightTooltip>
                    <LightTooltip placement="left" title="Drill Down Shipment">
                        <IconButton onClick={() => IconClickfordrillDownShip(2)} sx={{ background: 'white', p: 0.3 }} size="small" color="primary">
                            <LocalShippingIcon sx={{ padding: '0px 0px' }} />
                        </IconButton>
                    </LightTooltip>
                    <LightTooltip placement="left" title="Drill Down File">
                        <IconButton onClick={() => IconClickfordrillDownFile(3)} sx={{ background: 'white', p: 0.3 }} size="small" color="primary">
                            <DescriptionIcon sx={{ padding: '0px 0px' }} />
                        </IconButton>
                    </LightTooltip>
                    {/* <LightTooltip placement="left" title="Drill Down Trip">
            <IconButton className="iconButtonColor" onClick={() => IconClickfordrillDownTrip(4)} sx={{background:'white',p:0.3}} size="small" color="primary"><DescriptionIcon
            sx={{ padding: '0px 0px' }}
          /></IconButton>
          </LightTooltip> */}
                </Stack>
            </td>
        );
    }
};

export const CustomCellTooltip = (props, column) => {
    return (
        <td title={props.dataItem[column.field]}>
            {props.dataItem[column.field]}
        </td>
    );
};

const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.neutral.main,
        color: 'rgba(255, 255, 225, 0.99)',
        boxShadow: theme.shadows[10],
        fontSize: 14,
        paddingLeft: 25,
        paddingRight: 25,
    },
}));